
const digest = 'd4a24bb18c2ca1fca6c21728cf442ada594c7b45c03bf7f2f0a3ca4cfa3ed168';
const classes = {"button":"_button_1ub6d_1","controlsWrapper":"_controlsWrapper_1ub6d_21","cancelButton":"_cancelButton_1ub6d_26"};
const css = `._button_1ub6d_1 {
  border-color: #619612;
  background-color: #619612;
  font-family: Rubik, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 13px 16px;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  margin-top: 20px;
  border-radius: 25px;
}
._button_1ub6d_1:hover, ._button_1ub6d_1:active, ._button_1ub6d_1:focus {
  border-color: #4f790f !important;
  background-color: #4f790f !important;
}

._controlsWrapper_1ub6d_21 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
._controlsWrapper_1ub6d_21 ._cancelButton_1ub6d_26 {
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  